$(function() {
    var options = null;
    var slots = {
        weight: null,
        temperature: null,
        bloodPressure: null,
        heartRate: null,
        bloodSaturation: null,

        bloodGlucose: null,
        hematocrit: null,
        ketone: null,
        uricAcid: null,
        cholesterol: null,
        hemoglobin: null,
        lactate: null,
    };
    var $listDOM = $('[data-message]');
    var prefix = $listDOM.data('message') || '';
    if (prefix != '') {
        prefix = '-'+prefix;
    }

    var labels = {
        'associate_reading': document.querySelector('meta[name=associate_reading]').content,
        'go_back': document.querySelector('meta[name=go_back]').content,
        'accept': document.querySelector('meta[name=accept]').content,
        'reject': document.querySelector('meta[name=reject]').content,
        'new_reading_detected': document.querySelector('meta[name=new_reading_detected]').content,
        'weight': document.querySelector('meta[name=weight]').content,
        'temperature': document.querySelector('meta[name=temperature]').content,
        'blood_pressure': document.querySelector('meta[name=blood_pressure]').content,
        'heart_rate': document.querySelector('meta[name=heart_rate]').content,
        'blood_saturation': document.querySelector('meta[name=blood_saturation]').content,
        'blood_glucose': document.querySelector('meta[name=blood_glucose]').content,
        'hematocrit': document.querySelector('meta[name=hematocrit]').content,
        'ketone': document.querySelector('meta[name=ketone]').content,
        'uric_acid': document.querySelector('meta[name=uric_acid]').content,
        'cholesterol': document.querySelector('meta[name=cholesterol]').content,
        'hemoglobin': document.querySelector('meta[name=hemoglobin]').content,
        'lactate': document.querySelector('meta[name=lactate]').content,
    };

    if (!document.querySelector('meta[name=read_bluetooth]')) {
        return;
    }

    /*
    var serviceUrl = document.querySelector('meta[name=service_url]').content;
    var socket = null;

    if (typeof io !== 'undefined')
    {
        try {
            socket = io.connect(serviceUrl);
        } catch (error) {
            console.log(error);
            return;
        }

        socket.on('data bio', function (data) {
            // console.log(data);
            data.data.forEach(elData => {
                showMessage(elData);
            });
        });
    }
    */

    /*
    socket.on('cec data', function (data) {
        if (['up', 'down', 'left', 'right'].indexOf(data) >= 0) {
            SpatialNavigation.move(data);
        } else if (['exit'].indexOf(data) >= 0) {
            // SpatialNavigation.move(data);<
            window.history.back();
        } else if (['select'].indexOf(data) >= 0) {
            // SpatialNavigation.move(data);
            document.activeElement.click()
        }
    });
    */

    function showOptions() {
        return new Promise(function(resolve, reject) {
            if (options === null) {
                options = createElementOptions();
            }

            options.addClass('options--is-waiting');
            var $list = $('[data-list]', options);
            fetch('/patients/api/')
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    options.removeClass('options--is-waiting');
                    data.forEach(dataEl => {
                        $list.append(createElementOption(dataEl));
                    });
                });

            options.on('click', 'a[data-back]', function(e) {
                e.preventDefault();

                reject();
                close();

                return false;
            });

            options.on('click', 'a[data-id]', function(e) {
                e.preventDefault();

                resolve(this.dataset.id);
                close();

                return false;
            });

            $(document.body).append(options);

            setTimeout(function() {
                window.activeLevel3Navigation();
                options.addClass('options--is-show');
            }, 50);

            function close() {
                options.removeClass('options--is-show');
                window.activeLevel2Navigation();
                setTimeout(function() {
                    options.remove();
                    options = null;
                }, 300);
            }
        });
    }

    function createElementOptions() {
        return $([
            '<div class="options">',
                '<section>',
                    '<header>',
                        '<h1>', labels.associate_reading, '</h1>',
                        '<a class="button-back focusable focusable--is-level-3" href="#" data-no-loading data-back><i class="fas fa-arrow-left"></i> ', labels.go_back, '</a>',
                    '</header>',
                    '<main>',
                        '<section class="list" data-list></section>',
                    '</main>',
                    '<div class="options__waiting"><i class="fas fa-spinner"></i></div>',
                '</section>',
            '</div>',
        ].join(''));
    }

    function createElementOption(dataEl) {
        var picture = '';
        if (dataEl.isPicture) {
            picture = [
                '<div class="picture picture--has-size-xl" style="', dataEl.colorStyle, '">',
                    '<picture>',
                        '<source srcset="', dataEl.picture, '">',
                        '<img src="', dataEl.picture, '" />',
                    '</picture>',
                '</div>'
            ].join('');
        } else {
            picture = [
                '<div class="picture picture--has-size-xl" style="', dataEl.colorStyle, '">', dataEl.letterPlaceHolder, '</div>'
            ].join('');
        }

        return $([
            '<a class="list__item focusable focusable--is-level-3" href="#" data-no-loading data-id="', dataEl.id, '">',
                picture,
				'<div class="list__item-name">', dataEl.name, '</div>',
				'<div class="list__item-age">', dataEl.age, '</div>',
			'</a>'
        ].join(''));
    }

    function showMessage(data) {
        //$('#readingdata').fadeIn('fast');

        var $elem = getSlot(data);

        if ($elem !== null) {

            if (getValue(data) == 0) {
                return;
            }

            $('[data-type]', $elem).html(getTitle(data));
            $('[data-title]', $elem).html(getTitle(data));
            $('[data-value]', $elem).html(getValue(data));
            $('[data-scale]', $elem).html(getScale(data));
            $('[data-day]', $elem).html(getDay());
            $('[data-hour]', $elem).html(getHour());

            $('[data-icon-header]', $elem).attr("src", getIconHeader(data));
            $('[data-icon-inner]', $elem).attr("src", getIconReading(data));

            $('[data-background]', $elem).removeClass("message"+prefix+"__item__background_overall").addClass(getClassReadingBackground(data));
            $('[data-background-icon]', $elem).removeClass("message"+prefix+"__item__background_icon").addClass(getClassReading(data));

            $('[data-background]', $elem).addClass(getClassTxt(data));

            $elem.detach();
            $listDOM.prepend($elem);

            $listDOM.children().each(function(idx) {
                $(this).removeClass('message'+prefix+'__item--is-nth4');
                $(this).removeClass('message'+prefix+'__item--is-nth3');
                $(this).removeClass('message'+prefix+'__item--is-nth2');
                $(this).removeClass('message'+prefix+'__item--is-nth1');

                $(this).addClass('message'+prefix+'__item--is-nth'+(4-idx));
            });

            return;
        }

        $elem = createElement();

        if (getValue(data) == 0) {
            return;
        }

        $('[data-type]', $elem).html(getTitle(data));
        $('[data-title]', $elem).html(getTitle(data));
        $('[data-value]', $elem).html(getValue(data));
        $('[data-scale]', $elem).html(getScale(data));
        $('[data-day]', $elem).html(getDay());
        $('[data-hour]', $elem).html(getHour());

        $('[data-icon-header]', $elem).attr("src", getIconHeader(data));
        $('[data-icon-inner]', $elem).attr("src", getIconReading(data));

        $('[data-background]', $elem).removeClass("message"+prefix+"__item__background_overall").addClass(getClassReadingBackground(data));
        $('[data-background-icon]', $elem).removeClass("message"+prefix+"__item__background_icon").addClass(getClassReading(data));

        $('[data-background]', $elem).addClass(getClassTxt(data));

        setTimeout(function() {
            $elem.addClass('message'+prefix+'__item--is-show');
            //window.activeLevel2Navigation();
        }, 300);

        $listDOM.prepend($elem);

        $listDOM.children().each(function(idx) {
            $(this).removeClass('message'+prefix+'__item--is-nth4');
            $(this).removeClass('message'+prefix+'__item--is-nth3');
            $(this).removeClass('message'+prefix+'__item--is-nth2');
            $(this).removeClass('message'+prefix+'__item--is-nth1');

            $(this).addClass('message'+prefix+'__item--is-nth'+(4-idx));
        });

        setSlot(data, $elem);

        $elem.on('click', 'a[data-ok]', function(e) {
            e.preventDefault();

            if ($('meta[name=patient]').length > 0) {
                var element = $('meta[name=patient_id]').get(0);
                var patientId = element.content;
                sendReading(patientId);
            } else {
                showOptions().then(function(patientId) {
                    return sendReading(patientId);
                }, function() {
                    window.activeLevel1Navigation();
                    remove();
                });
            }

            function sendReading(id) {
                return new Promise(function(resolve, reject) {
                    $elem.addClass('message'+prefix+'__item--is-waiting');

                    var opts = {};
                    if ("blood-pressure" === data.type) {
                        opts = {
                            patient: id,
                            type: data.type,
                            valueLow: data.valueLow,
                            valueHigh: data.valueHigh
                        };
                    } else {
                        opts = {
                            patient: id,
                            type: data.type,
                            value: data.value
                        };
                    }

                    fetch('/readings/api/', {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(opts)
                        })
                        .then(function(response) {
                            return response.json();
                        })
                        .then(function(data) {
                            window.activeLevel1Navigation();
                            remove();
                            resolve();
                            var url = location.href.split('/');
                            if (url.indexOf('patients') === 3 && url.length === 6) {
                                updateDataInDashboard();
                            }
                        }, function(err) {
                            reject(err);
                        });
                });
            }

            return false;
        });

        $elem.on('click', 'a[data-cancel]', function(e) {
            e.preventDefault();
            window.activeLevel1Navigation();
            remove();
            return false;
        });

        function remove() {
            cleanSlot(data);
            $elem.removeClass('message'+prefix+'__item--is-show');
            setTimeout(function() {
                $elem.addClass('message'+prefix+'__item--is-compact');
            }, 300);
            setTimeout(function() {

                $elem.remove();
                $listDOM.children().each(function(idx) {
                    $(this).removeClass('message'+prefix+'__item--is-nth4');
                    $(this).removeClass('message'+prefix+'__item--is-nth3');
                    $(this).removeClass('message'+prefix+'__item--is-nth2');
                    $(this).removeClass('message'+prefix+'__item--is-nth1');

                    $(this).addClass('message'+prefix+'__item--is-nth'+(4-idx));
                });
            }, 600);
        }
    }

    function createElement(data) {
        return $([
            '<div class="message'+prefix+'__item"><div class="message'+prefix+'__item__inner">',
            // '<div class=message__item__headerIcon>',
            //     '<div class="message'+prefix+'__icon_top"><img  data-icon-header src="/assets/elements_kiosk/e_tensiometer.svg"></div>',
            // '</div>',
            '<div class=message__item__headerDesc>',
                '<div class="message'+prefix+'__type_top" >', labels.new_reading_detected, '</div>',
                // '<div class="message'+prefix+'__type_subtop" data-type>Oximeter</div>',
            '</div>',
            // '<div class=message__item__headerTimer>',
            //     '<div class="message'+prefix+'__type_day" data-day></div>',
            //     '<div class="message'+prefix+'__type_hour" data-hour></div>',
            //     '<div style="clear:both;"></div>',
            // '</div>',
            '<div style="clear:both;"></div>',
            '<main data-background class="message'+prefix+'__item__background_overall">',
                '<div class="message'+prefix+'__icon message__item__background_icon" data-background-icon><img data-icon-inner src="/assets/elements_kiosk/e_tensiometer.svg"></div>',
                '<div class="message'+prefix+'__info_datavalues">',
                    '<div class="message'+prefix+'__type" data-title>c</div>',
                    '<div class="message'+prefix+'__info_datavalues2">',
                        '<div class="message'+prefix+'__value" data-value></div>',
                        '<div class="message'+prefix+'__scale" data-scale></div>',
                    '</div>',
                '</div>',
            '</main>',
                '<footer>',
                    '<div class="mb__left"><a href="#" data-no-loading data-ok class="focusable focusable--is-level-1 message__button">', labels.accept, '</a></div>',
                    '<div class="mb__right"><a href="#" data-no-loading data-cancel class="focusable focusable--is-level-1 message__button message__button--is-warning">', labels.reject, '</a></div>',
                '</footer>',
                '<div class="message'+prefix+'__item-waiting"><i class="fas fa-spinner"></i></div>',
            '</div></div>',
        ].join(''));
    }

    function getIconHeader(data) {
        var icon_folder = '/assets/elements_kiosk/';
        if ("weight" === data.type) {
            return icon_folder + 'e_balance.svg';
        } else if ("temperature" === data.type) {
            return icon_folder + 'e_thermometer.svg';
        } else if ("blood-pressure" === data.type) {
            return icon_folder + 'e_tensiometer.svg';
        } else if ("heart-rate" === data.type) {
            return icon_folder + 'e_balance.svg';
        } else if ("blood-saturation" === data.type) {
            return icon_folder + 'e_oximeter.svg';
        } else if ("blood-glucose" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("hematocrit" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("ketone" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("uric-acid" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("cholesterol" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("hemoglobin" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        } else if ("lactate" === data.type) {
            return icon_folder + 'e_glucometer.svg';
        }
        return icon_folder + 'e_glucometer.svg';
    }


    function getIconReading(data) {
        var icon_folder = '/assets/elements_kiosk/';
        if ("weight" === data.type) {
            return icon_folder + 'e_weight_w.svg';
        } else if ("temperature" === data.type) {
            return icon_folder + 'e_temperature_w.svg';
        } else if ("blood-pressure" === data.type) {
            return icon_folder + 'e_blood-pressure_w.svg';
        } else if ("heart-rate" === data.type) {
            return icon_folder + 'e_heart-rate_w.svg';
        } else if ("blood-saturation" === data.type) {
            return icon_folder + 'e_blood-saturation_w.svg';
        } else if ("blood-glucose" === data.type) {
            return icon_folder + 'e_glu_w.svg';
        } else if ("hematocrit" === data.type) {
            return icon_folder + 'xxxx.svg';
        } else if ("ketone" === data.type) {
            return icon_folder + 'e_bk_w.svg';
        } else if ("uric-acid" === data.type) {
            return icon_folder + 'e_ua_w.svg';
        } else if ("cholesterol" === data.type) {
            return icon_folder + 'e_chol_w.svg';
        } else if ("hemoglobin" === data.type) {
            return icon_folder + 'xxxx.svg';
        } else if ("lactate" === data.type) {
            return icon_folder + 'e_lac_w.svg';
        }
        return icon_folder + 'e_vitals_w.svg';
    }


    function getClassTxt(data) {

        if ("weight" === data.type) {
            return 'txt--cor-body-weight';
        } else if ("temperature" === data.type) {
            return 'txt--cor-temperature';
        } else if ("blood-pressure" === data.type) {
            return 'txt--cor-blood-pressure';
        } else if ("heart-rate" === data.type) {
            return 'txt--cor-heart-rate';
        } else if ("blood-saturation" === data.type) {
            return 'txt--cor-blood-saturation';
        } else if ("blood-glucose" === data.type) {
            return 'txt--cor-glucose';
        } else if ("hematocrit" === data.type) {
            return 'txt--cor-readinggeral';
        } else if ("ketone" === data.type) {
            return 'txt--cor-ketone';
        } else if ("uric-acid" === data.type) {
            return 'txt--cor-uric-acid';
        } else if ("cholesterol" === data.type) {
            return 'txt--cor-colesterol';
        } else if ("hemoglobin" === data.type) {
            return 'txt--cor-readinggeral';
        } else if ("lactate" === data.type) {
            return 'txt--cor-lactate';
        }
        return 'txt--cor-readinggeral';
    }

    function getClassReading(data) {
        if ("weight" === data.type) {
            return 'background--cor-body-weight';
        } else if ("temperature" === data.type) {
            return 'background--cor-temperature';
        } else if ("blood-pressure" === data.type) {
            return 'background--cor-blood-pressure';
        } else if ("heart-rate" === data.type) {
            return 'background--cor-heart-rate';
        } else if ("blood-saturation" === data.type) {
            return 'background--cor-blood-saturation';
        } else if ("blood-glucose" === data.type) {
            return 'background--cor-glucose';
        } else if ("hematocrit" === data.type) {
            return 'background--cor-readinggeral';
        } else if ("ketone" === data.type) {
            return 'background--cor-ketone';
        } else if ("uric-acid" === data.type) {
            return 'background--cor-uric-acid';
        } else if ("cholesterol" === data.type) {
            return 'background--cor-colesterol';
        } else if ("hemoglobin" === data.type) {
            return 'background--cor-readinggeral';
        } else if ("lactate" === data.type) {
            return 'background--cor-lactate';
        }
        return 'background--cor-readinggeral';
    }


    function getClassReadingBackground(data) {
        if ("weight" === data.type) {
            return 'background--cor-body-weight2';
        } else if ("temperature" === data.type) {
            return 'background--cor-temperature2';
        } else if ("blood-pressure" === data.type) {
            return 'background--cor-blood-pressure2';
        } else if ("heart-rate" === data.type) {
            return 'background--cor-heart-rate2';
        } else if ("blood-saturation" === data.type) {
            return 'background--cor-blood-saturation2';
        } else if ("blood-glucose" === data.type) {
            return 'background--cor-glucose2';
        } else if ("hematocrit" === data.type) {
            return 'background--cor-readinggeral2';
        } else if ("ketone" === data.type) {
            return 'background--cor-ketone2';
        } else if ("uric-acid" === data.type) {
            return 'background--cor-uric-acid2';
        } else if ("cholesterol" === data.type) {
            return 'background--cor-colesterol2';
        } else if ("hemoglobin" === data.type) {
            return 'background--cor-readinggeral2';
        } else if ("lactate" === data.type) {
            return 'background--cor-lactate2';
        }
        return 'background--cor-readinggeral2';
    }

    function getDay() {
        var today = new Date();
        var dd = today.getDate();

        var mm = today.getMonth()+1;
        var yyyy = today.getFullYear();
        if(dd<10)  dd='0'+dd;

        if(mm<10) mm='0'+mm;

        today = dd+' / '+mm+' / '+yyyy;
        return today;
    }
    function getHour() {
        var today = new Date();

        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();

        if(h<10)  h='0'+h;
        if(m<10) m='0'+m;
        if(s<10) s='0'+s;

        timex = h+':'+m; //+':'+s;
        return timex;
    }


    function getSlot(data) {
        if ("weight" === data.type) {
            return slots.weight;
        } else if ("temperature" === data.type) {
            return slots.temperature;
        } else if ("blood-pressure" === data.type) {
            return slots.bloodPressure;
        } else if ("heart-rate" === data.type) {
            return slots.heartRate;
        } else if ("blood-saturation" === data.type) {
            return slots.bloodSaturation;
        } else if ("blood-glucose" === data.type) {
            return slots.bloodGlucose;
        } else if ("hematocrit" === data.type) {
            return slots.hematocrit;
        } else if ("ketone" === data.type) {
            return slots.ketone;
        } else if ("uric-acid" === data.type) {
            return slots.uricAcid;
        } else if ("cholesterol" === data.type) {
            return slots.cholesterol;
        } else if ("hemoglobin" === data.type) {
            return slots.hemoglobin;
        } else if ("lactate" === data.type) {
            return slots.lactate;
        }
        return null;
    }

    function setSlot(data, $el) {
        if ("weight" === data.type) {
            slots.weight = $el;
        } else if ("temperature" === data.type) {
            slots.temperature = $el;
        } else if ("blood-pressure" === data.type) {
            slots.bloodPressure = $el;
        } else if ("heart-rate" === data.type) {
            slots.heartRate = $el;
        } else if ("blood-saturation" === data.type) {
            slots.bloodSaturation = $el;
        } else if ("blood-glucose" === data.type) {
            slots.bloodGlucose = $el;
        } else if ("hematocrit" === data.type) {
            slots.hematocrit = $el;
        } else if ("ketone" === data.type) {
            slots.ketone = $el;
        } else if ("uric-acid" === data.type) {
            slots.uricAcid = $el;
        } else if ("cholesterol" === data.type) {
            slots.cholesterol = $el;
        } else if ("hemoglobin" === data.type) {
            slots.hemoglobin = $el;
        } else if ("lactate" === data.type) {
            slots.lactate = $el;
        }
    }

    function cleanSlot(data) {
        if ("weight" === data.type) {
            slots.weight = null;
        } else if ("temperature" === data.type) {
            slots.temperature = null;
        } else if ("blood-pressure" === data.type) {
            slots.bloodPressure = null;
        } else if ("heart-rate" === data.type) {
            slots.heartRate = null;
        } else if ("blood-saturation" === data.type) {
            slots.bloodSaturation = null;
        } else if ("blood-glucose" === data.type) {
            slots.bloodGlucose = null;
        } else if ("hematocrit" === data.type) {
            slots.hematocrit = null;
        } else if ("ketone" === data.type) {
            slots.ketone = null;
        } else if ("uric-acid" === data.type) {
            slots.uricAcid = null;
        } else if ("cholesterol" === data.type) {
            slots.cholesterol = null;
        } else if ("hemoglobin" === data.type) {
            slots.hemoglobin = null;
        } else if ("lactate" === data.type) {
            slots.lactate = null;
        }
    }

    function getTitle(data) {
        if ("weight" === data.type) {
            return labels.weight; // 'Peso';
        } else if ("temperature" === data.type) {
            return labels.temperature; // 'Temperatura';
        } else if ("blood-pressure" === data.type) {
            return labels.blood_pressure; // 'Pressão Sanguínea';
        } else if ("heart-rate" === data.type) {
            return labels.heart_rate; // 'Frequência cardíaca';
        } else if ("blood-saturation" === data.type) {
            return labels.blood_saturation; // 'Saturação de oxigênio';
        } else if ("blood-glucose" === data.type) {
            return labels.blood_glucose; // 'Glicose no Sangue';
        } else if ("hematocrit" === data.type) {
            return labels.hematocrit; // 'Hematócrito';
        } else if ("ketone" === data.type) {
            return labels.ketone; // 'Cetona';
        } else if ("uric-acid" === data.type) {
            return labels.uric_acid; // 'Ácido Úrico';
        } else if ("cholesterol" === data.type) {
            return labels.cholesterol; // 'Colesterol';
        } else if ("hemoglobin" === data.type) {
            return labels.hemoglobin; // 'Hemoglobina';
        } else if ("lactate" === data.type) {
            return labels.lactate; // 'Ácido Láctico';
        }
        return '';
    }

    function getScale(data) {
        if ("weight" === data.type) {
            return 'kg';
        } else if ("temperature" === data.type) {
            return 'ºC';
        } else if ("blood-pressure" === data.type) {
            return 'mmHg';
        } else if ("heart-rate" === data.type) {
            return 'bpm';
        } else if ("blood-saturation" === data.type) {
            return '%';
        } else if ("blood-glucose" === data.type) {
            return 'mg/dL';
        } else if ("hematocrit" === data.type) {
            return '%';
        } else if ("ketone" === data.type) {
            return 'mmol/L';
        } else if ("uric-acid" === data.type) {
            return 'mg/dL';
        } else if ("cholesterol" === data.type) {
            return 'mg/dL';
        } else if ("hemoglobin" === data.type) {
            return 'g/dL';
        } else if ("lactate" === data.type) {
            return 'mmol/L';
        }
        return '';
    }

    function getValue(data) {
        if ("weight" === data.type) {
            return data.value;
        } else if ("temperature" === data.type) {
            return data.value;
        } else if ("blood-pressure" === data.type) {
            return data.valueHigh + ' / ' + data.valueLow;
        } else if ("heart-rate" === data.type) {
            return data.value;
        } else if ("blood-saturation" === data.type) {
            return data.value;
        } else if ("blood-glucose" === data.type) {
            return data.value;
        } else if ("hematocrit" === data.type) {
            return data.value;
        } else if ("ketone" === data.type) {
            return data.value;
        } else if ("uric-acid" === data.type) {
            return data.value;
        } else if ("cholesterol" === data.type) {
            return data.value;
        } else if ("hemoglobin" === data.type) {
            return data.value;
        } else if ("lactate" === data.type) {
            return data.value;
        }
        return '-';
    }

    function updateDataInDashboard() {
        var url = $('meta[name=refresh]').get(0).content;
        function fetchData() {
            fetch(url)
                .then(response => response.json())
                .then(function(response) {
                    update(response);
                });
        }
        function update(response) {
            if (!response.ok) {
                return;
            }
            var data = response.data;
            console.log(data);

            updateFieldIfChange('heart-rate', data.heart_rate);
            updateFieldIfChange('blood-pressure', data.blood_pressure);
            updateFieldIfChange('temperature', data.temperature);
            updateFieldIfChange('blood-saturation', data.blood_saturation);
            updateFieldIfChange('activity', data.activity);
            updateFieldIfChange('weight', data.weight);
            updateFieldIfChange('blood-glucose', data.blood_glucose);
            updateFieldIfChange('cholesterol', data.cholesterol);
            updateFieldIfChange('ketone', data.ketone);
            updateFieldIfChange('lactate', data.lactate);
            updateFieldIfChange('uric-acid', data.uric_acid);
        }
        function updateFieldIfChange(key, data) {
            var $field = $('[data-'+key+']');
            if ($field.length === 0) {
                return;
            }
            var field = $field.get(0);
            var valueNow = $('[data-value]', field).html();

            console.log(data);

            var mValue = data.value;
            if ("blood-pressure" === key) {
                mValue = data.value_for_humans;
            }

            if (valueNow != mValue) {
                $field.addClass('dashboard__widget--has-new-value');
                setTimeout(function() {
                    $field.removeClass('dashboard__widget--has-new-value');
                }, 1200);
            }

            $('[data-time]', field).html(data.time_pass);
            $('[data-value]', field).html(mValue);

            $('[data-acc]', field).removeClass('dashboard__widget-acc--is-light-blue');
            $('[data-acc]', field).removeClass('dashboard__widget-acc--is-green');
            $('[data-acc]', field).removeClass('dashboard__widget-acc--is-yellow');
            $('[data-acc]', field).removeClass('dashboard__widget-acc--is-blue');
            if (1 == data.acc) {
                $('[data-acc]', field).html($('meta[name=acc_label_1]').get(0).content);
                $('[data-acc]', field).addClass('dashboard__widget-acc--is-light-blue');
            } else if (10 == data.acc) {
                $('[data-acc]', field).html($('meta[name=acc_label_10]').get(0).content);
                $('[data-acc]', field).addClass('dashboard__widget-acc--is-green');
            } else if (100 == data.acc) {
                $('[data-acc]', field).html($('meta[name=acc_label_100]').get(0).content);
                $('[data-acc]', field).addClass('dashboard__widget-acc--is-yellow');
            } else {
                $('[data-acc]', field).html($('meta[name=acc_label]').get(0).content);
                $('[data-acc]', field).addClass('dashboard__widget-acc--is-blue');
            }
        }
        fetchData();
    }

    window.few = function() {
        updateDataInDashboard();
    }
    window.dumm = function() {
        showMessage({
            type: 'heart-rate',
            value: 125
        });

        showMessage({
            type: 'temperature',
            value: 125
        });

        showMessage({
            type: 'blood-pressure',
            valueLow: 80,
            valueHigh: 125
        })
    }

    // setTimeout(function() { showMessage({
    //     type: 'blood-pressure',
    //     valueLow: 80,
    //     valueHigh: 125
    // }) }, 7000);

    // showMessage({
    //     type: 'weight',
    //     value: 125
    // });

    // showMessage({
    //     type: 'temperature',
    //     value: 125
    // });

    // showMessage({
    //     type: 'heart-rate',
    //     value: 80
    // });

    // --------------------------

    // showMessage({
    //     type: 'blood-glucose',
    //     value: 10.2
    // });

    // showMessage({
    //     type: 'hematocrit',
    //     value: 75
    // });

    // showMessage({
    //     type: 'ketone',
    //     value: 10
    // });

    // showMessage({
    //     type: 'uric-acid',
    //     value: 3.2
    // });

    // showMessage({
    //     type: 'cholesterol',
    //     value: 41
    // });

    // showMessage({
    //     type: 'hemoglobin',
    //     value: 87
    // });

    // showMessage({
    //     type: 'lactate',
    //     value: 47
    // });

    // showMessage({
    //     type: 'lactate',
    //     value: 0
    // });

    // setTimeout(() => {
    //     showMessage({
    //         type: 'lactate',
    //         value: 47
    //     });
    // }, 20000);
});